import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {ModalRef, ModalService} from "ng-zorro-antd-mobile";
import {Subscription} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {YzSelectContactsService} from "../yz-select-contacts/yz-select-contacts.service";
import {YzRoleSelectContactsService} from "./yz-role-select-contacts.service";
import {GroupRoleInterface, ComponentOption} from "./groupRole.interface";
import {BaseUserInterface} from "../yz-select-contacts/dept.interface";

@Component({
  selector: 'yz-role-select-contacts',
  templateUrl: './yz-role-select-contacts.component.html',
  styleUrls: ['./yz-role-select-contacts.component.less']
})
export class YzRoleSelectContactsComponent implements OnInit, OnDestroy {

  modalRefCpt: Array<ModalRef> = [];
  subscribed: Array<Subscription> = [];
  dtPullToRefreshStyle = {height: window.innerHeight - 44 - 51 - 44 + 'px'};

  // 总角色组数据
  roleNodes: Array<GroupRoleInterface> = [];

  // 页面展示的角色组数据
  groupRoleList: Array<{ value: string, label: string, children?: Array<{ value: string, label: string }> }> = [];

  // 当前角色
  currentRole: Array<{ value: string, label: string }> = [];

  // 页面加载中
  pageLoading: boolean = false;

  // 人员列表参数
  baseUserParams = {
    total: 0,
    pageSize: 20,
    pageNum: 1,
    realName: null
  };

  // 人员数据
  baseUserList: Array<BaseUserInterface> = [];

  // 是否全选人员
  allUserCheck: boolean = false;

  // 已选择的联系人
  selectedContacts: Array<BaseUserInterface> = [];


  constructor(
    public dialogRef: MatDialogRef<YzRoleSelectContactsComponent>,
    private _modal: ModalService,
    private yzContactsService: YzSelectContactsService,
    private yzRoleContactsService: YzRoleSelectContactsService,
    @Inject(MAT_DIALOG_DATA) public data: ComponentOption
  ) {
  }

  ngOnInit() {
    this.initGroupRole();
  }

  // 查询角色组
  initGroupRole() {
    this.groupRoleList = [];
    this.roleNodes = [];
    this.pageLoading = true;
    const $temp = this.yzRoleContactsService.getGroupRole(this.data.roleGroupCode).subscribe((role: Array<GroupRoleInterface>) => {
      this.pageLoading = false;
      this.roleNodes = role;
      this.roleNodes.forEach((item) => {
        const obj = {
          value: item.key,
          label: item.title,
          children: []
        };
        if (item.children && item.children.length > 0) {
          item.children.forEach((role) => {
            obj.children.push({
              value: role.key,
              label: role.title,
            });
          })
        }
        this.groupRoleList.push(obj);
      });

      this.groupRoleList.unshift({
        value: null,
        label: '全部'
      });

      if (this.roleNodes.length > 0) {
        if (this.roleNodes[0].children.length > 0) {
          this.currentRole = [this.groupRoleList[1].children[0]];
        }
      }

      this.queryDefaultContact();

      this.subscribed.push($temp);
    }, () => {
      this.pageLoading = false;
    });
  }


  // 查询默认已被选择人员的信息
  queryDefaultContact() {
    if (this.data.defaultContacts && this.data.defaultContacts.length > 0) {
      const userIdsArray: Array<any> = [];
      this.data.defaultContacts.forEach((item) => {
        if (item.userId) {
          userIdsArray.push(item.userId);
        }
      });
      this.pageLoading = true;
      const $temp = this.yzContactsService.getUserByUserIds(userIdsArray).subscribe((data: Array<BaseUserInterface>) => {
        this.pageLoading = false;
        this.selectedContacts = data;
        this.queryBaseUser();
        this.subscribed.push($temp);
      }, () => {
        this.pageLoading = false;
      });
    } else {
      this.queryBaseUser();
    }
  }

  // 查询人员列表
  queryBaseUser() {
    this.pageLoading = true;
    const $temp = this.yzRoleContactsService.getBaseUser(
      this.baseUserParams.pageNum,
      this.baseUserParams.pageSize,
      this.baseUserParams.realName,
      this.currentRole.length > 0 ? this.currentRole[this.currentRole.length-1].value : null,
      this.data.userTypes
    ).subscribe((data: any) => {
      this.pageLoading = false;
      this.baseUserParams.total = data.total;
      this.baseUserList.push(...data.list);
      this.baseUserList.forEach((item) => {
        item['checked'] = false;
        item['disabled'] = false;
        if (!item.dept) {
          item.dept = {deptName: '暂无部门'}
        }
        if (!item.realName) {
          item.realName = '暂无姓名';
        }
        if (!item.userCode) {
          item.realName = '暂无学/工号'
        }
        if (!item.roles) {
          item.roles = [];
          item.rolesData = '暂无角色';
        } else {
          const roleArray = [];
          item.roles.forEach((value) => {
            roleArray.push(value.roleName);
          });
          item.rolesData = roleArray.toString();
        }
        this.selectedContacts.forEach((value) => {
          if (value.userId === item.userId) {
            item['checked'] = true;
          }
        });
      });
      this.isMaxCount();

      this.subscribed.push($temp);
    }, () => {
      this.pageLoading = false;
    });
  }

  // 刷新回调函数
  pullToRefresh() {
    if (this.baseUserList.length < this.baseUserParams.total) {
      this.baseUserParams.pageNum++;
      this.queryBaseUser();
    }
  }

  // 根据用户姓名即时搜索人员
  queryUserByRealName() {
    this.baseUserParams.pageNum = 1;
    this.baseUserList = [];
    this.queryBaseUser();
  }

  // 取消——根据用户姓名即时搜索人员
  cancelQueUserByRealName() {
    this.baseUserParams.realName = null;
    this.baseUserParams.pageNum = 1;
    this.baseUserList = [];
    this.queryBaseUser();
  }

  // 切换角色
  onChangeRole($event) {
    if ($event && $event.length && $event.length > 0) {
      this.currentRole = $event;
    } else {
      this.currentRole = [{
        value: null,
        label: '全部'
      }];
    }

    this.baseUserParams.pageNum = 1;
    this.baseUserList = [];
    this.queryBaseUser();
  }


  // 人员选择变化的回调
  userCheckedChange($event) {
    if ($event.checked) { // 选中
      this.allUserCheck = this.baseUserList.every((item) => {
        return item.checked === true;
      });

    } else { // 取消
      let itemIndex = 0;
      this.selectedContacts.forEach((value, index) => {
        if (value.userId === $event.value) {
          itemIndex = index;
        }
      });
      this.deleteContact($event.value, itemIndex);
    }

    this.addBaseUser();
  }

  // 将人员列表中选中项添加至已选择的人员列表中
  addBaseUser() {
    this.baseUserList.forEach((item) => {
      const hasThisMen = this.selectedContacts.some((value) => {
        return value.userId === item.userId
      });
      if (item.checked && !hasThisMen) {
        this.selectedContacts.push(item);
      }
    });

    this.isMaxCount();
  }

  // 人数选择达到最大值
  isMaxCount() {
    if (this.data.count > 0 && this.selectedContacts.length >= this.data.count) {
      this.selectedContacts.length = this.data.count;
      this.baseUserList.forEach((item) => {
        const hasThisUser = this.selectedContacts.some((value) => {
          return item.userId === value.userId
        });

        if (!hasThisUser) {
          item.checked = false;
          item.disabled = true;
        }
      })
    } else {
      this.baseUserList.forEach((item) => {
        item.disabled = false;
      })
    }

    if (this.baseUserList.length == 0) {
      this.allUserCheck = false;
    } else {
      this.allUserCheck = this.baseUserList.every((item) => {
        return item.checked === true;
      });
    }
  }

  // 删除联系人
  deleteContact(id, index) {
    this.selectedContacts.splice(index, 1);
    this.baseUserList.forEach((item) => {
      if (item.userId === id) {
        item.checked = false;
      }
    });
    if (this.baseUserList.length == 0) {
      this.allUserCheck = false;
    } else {
      this.allUserCheck = this.baseUserList.every((item) => {
        return item.checked === true;
      });
    }
  }


  // 全选
  allSelect() {
    this.allUserCheck = true;
    this.baseUserList.forEach((item) => {
      item.checked = true;
    });
    this.addBaseUser();
  }

  // 取消全选
  cancelAllSelect() {
    this.allUserCheck = false;
    this.baseUserList.forEach((item) => {
      let itemIndex = 0;
      this.selectedContacts.forEach((value, index) => {
        if (value.userId === item.userId) {
          itemIndex = index;
        }
      });
      this.deleteContact(item.userId, itemIndex);
    })
  }



  // 点“完成”按钮，完成人员选择
  confirmSelect() {
    this.dialogRef.close(this.selectedContacts);
  }

  ngOnDestroy(): void {
    this.subscribed.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });

    this.modalRefCpt.forEach((ref: ModalRef) => {
      ref.destroy();
    });
  }
}
